<template>
    <div
        class="t-shops-row"
        style="width: 100%"
        :class="{ 't-shops-row--active': shopCheckbox }"
    >
        <ui-checkbox-input
            class="text-primary text-sm"
            :name="`shop-${promotion.id}-${priceGroupIdx}-${sub}`"
            v-model="shopCheckbox"
            @click.native="printError"
            :disabled="isCheckedInAnotherPriceGroup || isNextPriceGroup"
            :label="setShopLabel"
        />
        <div class="t-shops-rowError text-sm mt-2" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import { wtMerchants } from '@/walkthroughs/wtData'
export default {
    data() {
        return {
            error: ''
        }
    },
    props: {
        sub: {
            type: Number,
            required: true
        },
        promotion: {
            type: Object,
            required: true
        },
        selectedShops: {
            type: Array,
            required: true
        },
        priceGroupIdx: {
            type: Number,
            required: true
        },
        promoGroupId: {
            type: Number,
            required: true
        },
        previewType: {
            type: String,
            required: true
        }
    },
    computed: {
        shop() {
            if (this.$store.getters.getWalkthroughActive) {
                return wtMerchants.find(el => el.id === this.sub)
            } else {
                return this.$store.getters.getMerchantById(this.sub)
            }
        },
        isCheckedInAnotherPriceGroup() {
            let checkboxDisabled = false
            this.promotion.subscriptionsEqualPrices.priceGroups.forEach(
                (el, idx) => {
                    if (
                        el.find(child => child.merchant_id === this.sub) &&
                        el.find(child => child.merchant_id === this.sub)
                            .checked &&
                        idx !== this.priceGroupIdx
                    ) {
                        checkboxDisabled = true
                    }
                }
            )
            return checkboxDisabled
        },
        isNextPriceGroup() {
            let checkboxDisabled = false
            const thisPriceGroup = this.promotion.subscriptionsEqualPrices
                .priceGroups[this.priceGroupIdx]
            const checkedSubs = thisPriceGroup.filter(el => el.checked)
            const nextPriceGroup = this.promotion.subscriptionsEqualPrices
                .priceGroups[this.priceGroupIdx + 1]
            if (
                nextPriceGroup &&
                checkedSubs.length === 1 &&
                this.shopCheckbox
            ) {
                checkboxDisabled = true
            }
            return checkboxDisabled
        },
        shopCheckbox: {
            get() {
                return this.promotion.subscriptionsEqualPrices.priceGroups[
                    this.priceGroupIdx
                ].find(el => el.merchant_id === this.sub).checked
            },
            set(value) {
                this.$store.dispatch('selectShop', {
                    value,
                    promoId: this.promotion.id,
                    shopId: this.sub,
                    equalPrices: true,
                    groupIdx: this.priceGroupIdx,
                    groupId: this.promoGroupId,
                    promotion: this.promotion,
                    previewType: this.previewType,
                    fromPromoDetails: this.$store.getters.modalState?.args
                        ?.singleSubscription
                })
            }
        },
        setShopLabel() {
            const data = this.shop
            return `${data.name}, ${this.$store.getters.getShopAddress(data)}`
        }
    },
    methods: {
        printError() {
            if (this.isCheckedInAnotherPriceGroup) {
                this.error =
                    'By wybrać ten sklep, należy najpierw odznaczyć go z innej grupy cenowej'
            }
            if (this.isNextPriceGroup) {
                this.error =
                    'W tej grupie cenowej powinien być zaznaczony przynajmniej jeden sklep'
            }
            setTimeout(() => {
                if (this.error) {
                    this.error = ''
                }
            }, 4000)
        }
    }
}
</script>
